/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import {Card, CardContent, CardActions, CardMedia, Button, Divider} from '@mui/material'

import styled from 'styled-components'
import BackgroundImage from '../assets/images/background.jpg'
import { LoadingOverlay } from '../components/common'

import { AppContext } from '../stores/AppStore'
import { UserContext } from '../stores/UserStore'

const Background = styled.div`
  background: url(${BackgroundImage}) no-repeat center center fixed;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.background };
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.gray};
`

const ContentText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.gray};
  text-align: justify;
  width: 100%;
`
const WaitingAccess = (props) => {
  const history = useHistory()
  const { logo } = useContext(AppContext)
  const { applications, app, loadApp } = useContext(UserContext)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (applications) {
      loadApp().then().catch(error => {
        history.replace('/select-app')
      })
    } 
  }, [applications])     

  const onGoToLogin = () => {
    setIsLoading(true)    
    history.replace('/logout?app='+app.id)
  }

  const renderBackground = useMemo(() => <Background>
    <Card sx={{ width:'30vw', height:'30vh', padding:'10px', display: 'flex', flexDirection: 'column', justifyContent:'stretch', alignItems:'stretch' }}>
      <CardContent sx={{flex: '1 0 0'}}>
        <CardMedia image={logo} component="img" sx={{ width: '10vw', marginBottom: '40px' }} title="Logo..."/>
        {/* <Typography variant="h5" color="textSecondary" component="h2" sx={{ marginBottom: '5vh'}}>Waiting for Access!</Typography> */}
        <ContentText>
          <p>You have an request to access the <b>{app && app.label}</b> application!</p>
          <p>Please wait for maintainter's approval.</p>
        </ContentText>
      </CardContent>
      <Divider light sx={{ width: '100%'}} /> 
      <CardActions sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}> 
        <Button width="140px" onClick={onGoToLogin}>Go to Login</Button>
      </CardActions>
    </Card>
    <LoadingOverlay visible={isLoading}/>  
  </Background>, [app, isLoading])     

  return ( renderBackground )
}

export default WaitingAccess